import _ from 'lodash';
import moment from 'moment';
import { Firebase, callIfFunction, unwrapDoc, generateUnsafeHash, goalValueIsSet, unwrapDocs, logAndDispatchErrorForAction, withoutId, getCurrentTimestamp, accountId, organizationId, isProduction, omitDeleted, addKeysAsIds } from './../util';
import { OrganizationRef } from './../util/refs';

import {
  BEGIN_EDITING_GOALS,
  SAVE_GOALS,
  SAVE_GOALS_SUCCESS,
  SAVE_GOALS_ERROR,
  END_EDITING_GOALS,
} from './types';

export function beginEditingGoals(goals){
  return {
    type: BEGIN_EDITING_GOALS,
    payload: goals,
  };
}

export function endEditingGoals(){
  return {
    type: END_EDITING_GOALS,
  };
}

export function updateGoals(goals, callback){

  return dispatch => {

    dispatch({
      type: SAVE_GOALS
    });

    OrganizationRef().update({
      sprintGoals: goals
    }).then(() => {
      dispatch({
        type: SAVE_GOALS_SUCCESS,
        payload: goals
      });

      callIfFunction(callback, goals);

    }).catch(err => { logAndDispatchErrorForAction(`Update goals ${goals}`, err, dispatch, SAVE_GOALS_ERROR, callback) });

  }
}

export function addNewGoal(goal, callback){

  return dispatch => {

    dispatch({
      type: SAVE_GOALS
    });

    let newGoal = {...goal};

    newGoal.createdOn = getCurrentTimestamp();
    newGoal.id = generateUnsafeHash();

    OrganizationRef().get().then(doc => {
      const organization = unwrapDoc(doc);

      const updatedOrganizationSprintGoals = _.union(organization.sprintGoals, [ newGoal ]);

      OrganizationRef().update({
        sprintGoals: updatedOrganizationSprintGoals
      }).then(() => {
        dispatch({
          type: SAVE_GOALS_SUCCESS,
          payload: updatedOrganizationSprintGoals
        });

        callIfFunction(callback, updatedOrganizationSprintGoals);
      });
    }).catch(err => { logAndDispatchErrorForAction(`Save new goal ${newGoal}`, err, dispatch, SAVE_GOALS_ERROR, callback) });
  }
}

export function inactivateGoal(goal, callback){

  return dispatch => {

    dispatch({
      type: SAVE_GOALS
    });

    OrganizationRef().get().then(doc => {
      const organization = unwrapDoc(doc);

      let updatedOrganizationSprintGoals = organization.sprintGoals

      let goalToUpdate = _.find(updatedOrganizationSprintGoals, organizationGoal => {
        return organizationGoal.id === goal.id;
      });

      if(goalToUpdate){
        goalToUpdate.inactive = true;
        goalToUpdate.lastModified = getCurrentTimestamp();
      }

      //this mutates updatedOrganizationSprintGoals object

      OrganizationRef().update({
        sprintGoals: updatedOrganizationSprintGoals
      }).then(() => {
        dispatch({
          type: SAVE_GOALS_SUCCESS,
          payload: updatedOrganizationSprintGoals
        });

        callIfFunction(callback, updatedOrganizationSprintGoals);
      });
    }).catch(err => { logAndDispatchErrorForAction(`Inactivate goal ${goal}`, err, dispatch, SAVE_GOALS_ERROR, callback); });
  }
}

export function activateGoal(goal, callback){
  //do stuff
  return null;
}



// WEBPACK FOOTER //
// ./src/actions/goals.js